<template>
    <div class="az-credenciamento-fornecedor-itens">
        <listar-item-credenciamento-header-barra-botoes v-if="!deveBloqueiarAcoesDaTabela"
            :deveHabilitarBotoes="deveHabilitarBotoes"
            @savlarItensEAvancar="processarSavlarItensEAvancar"/>

        <div v-if="possuiGrupos" class="container-grupos">
            <h3 class="titulo-secao" style="color: #0067A5">Grupos</h3>
            <v-expansion-panel v-model="paineisGrupos" expand class="painel-grupos">
                <v-expansion-panel-content v-for="grupo in grupos" :key="grupo.loteId" class="painel-grupos__linha" style="color: #104D75">
                    <template v-slot:header>
                        <div class="cabecalho-grupo">
                            <v-checkbox
                                :input-value="isGrupoSelecionado(grupo.loteId)"
                                :disabled="deveBloqueiarAcoesDaTabela"
                                color="primary"
                                hide-details
                                @change="toggleGrupoSelection(grupo.loteId, $event)"
                                class="mr-3"
                            >
                                <template v-slot:label>
                                    <strong>{{ grupo.resumoDescricao }}</strong>
                                    <span class="info-grupo">
                                        ({{ grupo.itens.length }} {{ grupo.itens.length === 1 ? 'item' : 'itens' }})
                                    </span>
                                </template>
                            </v-checkbox>
                        </div>
                    </template>

                    <v-data-table
                        :headers="headersTabelaItensGrupo"
                        :items="grupo.itens"
                        :loading="false"
                        :disable-initial-sort="true"
                        hide-actions
                        class="az-table-list tabela-itens-grupo"
                    >
                        <template slot="items" slot-scope="props">
                            <td>{{ getTipoItemFromDescricao(props.item.descricaoSequencia) }}</td>
                            <td>{{ getSequenciaFromItemRow(props.item) }}</td>
                            <td style="display: flex; align-items: center; gap: 8px;">
                                <v-tooltip top class="tooltip-arredondado">
                                    <template #activator="{ on, attrs }">
                                        <chip-round
                                            v-bind="attrs"
                                            v-on="on"
                                            :label="getTipoMaterialServico(props.item.tipo, 'sigla')"
                                            :tamanho-fonte="'11px'"
                                        />
                                    </template>
                                    <span style="white-space: nowrap;">
                                        {{ getTipoMaterialServico(props.item.tipo, 'text') }}
                                    </span>
                                </v-tooltip>
                                <span class="mr-1"></span>
                                <texto-ver-mais
                                  :texto="props.item.descricao"
                                  :tamanho-maximo="120"
                                  :exibir-mensagem-ver-mais-ver-menos="true"
                                />
                            </td>
                            <td class="no-wrap">{{ props.item.unidade }}</td>
                            <td style="text-align: right;">
                                <formatador-moeda :valor="props.item.quantidade" :casas-decimais="casasDecimaisQuantidade"></formatador-moeda>
                            </td>
                            <td style="text-align: right;">
                                <formatador-moeda :valor="props.item.valorUnitario" :casas-decimais="licitacao.casasDecimais"></formatador-moeda>
                            </td>
                            <td style="text-align: right;">
                                <formatador-moeda :valor="props.item.valorTotal" :casas-decimais="2"></formatador-moeda>
                            </td>
                        </template>
                    </v-data-table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </div>
      
        <div v-if="possuiItensIndividuais" class="container-itens-individuais">
            <h3 class="titulo-secao" :class="{ 'mt-4': possuiGrupos }" style="color: #0067A5">Itens</h3>
            <v-data-table
                v-model="itensIndividuaisSelecionados"
                :headers="headersValidos"
                :items="itensIndividuais"
                :pagination.sync="pagination"
                select-all item-key="licitacaoLoteItemId"
                no-data-text="Não há itens individuais"
                class="az-table-list tabela-itens-individuais"
            >
                <template v-slot:headers="props">
                    <tr>
                        <th>
                            <v-checkbox
                                :disabled="deveBloqueiarAcoesDaTabela"
                                :input-value="props.all"
                                :indeterminate="props.indeterminate"
                                color="primary"
                                style="border: none !important;"
                                hide-details
                                @click.stop="marcarDesmarcarTodosItensIndividuais"
                            >
                                <template v-slot:label>
                                    <span class="primary--text" style="font-size: 12px; border: none !important;">Sel. Todos</span>
                                </template>
                            </v-checkbox>
                        </th>
                        <th
                            v-for="header in props.headers"
                            :key="header.text"
                            v-bind="header"
                            :class="['column sortable primary--text font-weight-bold', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                            @click.exact="changeSort(header.value)"
                        >
                            <v-icon small>arrow_upward</v-icon>
                            {{ header.text }}
                        </th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <td>
                        <v-checkbox
                            v-model="props.selected"
                            :disabled="deveBloqueiarAcoesDaTabela"
                            color="primary"
                            hide-details
                        />
                    </td>
                    <td>{{ getTipoItemFromDescricao(props.item.descricaoSequencia) }}</td>
                    <td>{{ getSequenciaFromItemRow(props.item) }}</td>
                    <td style="display: flex; align-items: center; gap: 8px;">
                        <v-tooltip top class="tooltip-arredondado">
                            <template #activator="{ on, attrs }">
                                <chip-round
                                    v-bind="attrs"
                                    v-on="on"
                                    :label="getTipoMaterialServico(props.item.tipo, 'sigla')"
                                    :tamanho-fonte="'11px'"
                                />
                            </template>
                            <span style="white-space: nowrap;">
                                {{ getTipoMaterialServico(props.item.tipo, 'text') }}
                            </span>
                        </v-tooltip>
                        <span class="mr-1"></span>
                        <texto-ver-mais
                          :texto="props.item.descricao"
                          :tamanho-maximo="120"
                          :exibir-mensagem-ver-mais-ver-menos="true"
                        />
                    </td>
                    <td class="no-wrap">{{ props.item.unidade }}</td>
                    <td style="text-align: right;">
                        <formatador-moeda :valor="props.item.quantidade" :casas-decimais="casasDecimaisQuantidade"></formatador-moeda>
                    </td>
                    <td style="text-align: right;">
                        <formatador-moeda :valor="props.item.valorUnitario" :casas-decimais="licitacao.casasDecimais"></formatador-moeda>
                    </td>
                    <td style="text-align: right;">
                        <formatador-moeda :valor="props.item.valorTotal" :casas-decimais="2"></formatador-moeda>
                    </td>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
    import {actionTypes, mutationTypes} from '@/commons/constants'
    import ListarItemCredenciamentoHeaderBarraBotoes from './component/ListarItemCredenciamentoHeaderBarraBotoes.vue'
    import FormatadorMoeda from '@/commons/components/FormatadorMoeda.vue'
    import ChipRound from '@/views/credenciamento/detalhe-credenciamento/commons/ChipRound.vue'
    import TextoVerMais from '@/views/credenciamento/detalhe-credenciamento/commons/TextoVerMais.vue'
import moment from "moment";
    import {normalizarCasasDecimais} from '@/commons/utils/CasasDecimaisUtils'

    export default {
        name: 'credenciamentoFornecedorItens',
        components: {
            ListarItemCredenciamentoHeaderBarraBotoes,
            FormatadorMoeda,
            ChipRound,
            TextoVerMais
        },
        data() {
            return {
                headers: [
                    {
                        text: 'Tipo',
                        align: 'left',
                        sortable: false,
                        value: 'tipoItem',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Seq.',
                        align: 'left',
                        sortable: false,
                        value: 'sequencia',
                        width: '80px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Código/Descrição',
                        value: 'descricao',
                        sortable: false,
                        align: 'left',
                        class: 'primary--text'
                    },
                    {
                        text: 'Un. Aquisição',
                        value: 'unidade',
                        sortable: false,
                        align: 'center',
                        class: 'primary--text'
                    },
                    {
                      text: 'Quantidade',
                      value: 'quantidade',
                      sortable: false,
                      align: 'center',
                      width: '100px',
                      class: 'primary--text'
                    },
                    {
                        text: 'Vlr. Unitário',
                        value: 'valorUnitario',
                        sortable: false,
                        align: 'right',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Vlr. Total',
                        value: 'valorTotal',
                        sortable: false,
                        align: 'center',
                        width: '100px',
                        class: 'primary--text'
                    }
                ],
                headersTabelaItensGrupo: [
                    {
                        text: 'Tipo',
                        align: 'left',
                        sortable: false,
                        value: 'tipoItem',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Seq.',
                        align: 'left',
                        sortable: false,
                        value: 'sequencia',
                        width: '80px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Código/Descrição',
                        value: 'descricao',
                        sortable: false,
                        align: 'left',
                        class: 'primary--text'
                    },
                    {
                        text: 'Un. Aquisição',
                        value: 'unidade',
                        sortable: false,
                        align: 'center',
                        class: 'primary--text'
                    },
                    {
                        text: 'Quantidade',
                        value: 'quantidade',
                        sortable: false,
                        align: 'center',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Vlr. Unitário',
                        value: 'valorUnitario',
                        sortable: false,
                        align: 'right',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Vlr. Total',
                        value: 'valorTotal',
                        sortable: false,
                        align: 'center',
                        width: '100px',
                        class: 'primary--text'
                    }
                ],
                pagination: {
                    sortBy: 'sequencia',
                    rowsPerPage: 10,
                    page: 1
                },
                itensSelecionados:[],
                itensIndividuaisSelecionados: [],
                gruposSelecionados: [],
                paineisGrupos: [],
                credenciamentoId: null,
                selecaoInicializada: false,
                selecaoGruposInicializada: false,
            }
        },
        computed: {
            casasDecimaisQuantidade() {
                return normalizarCasasDecimais(this.licitacao.casasDecimaisQuantidade)
            },
            deveHabilitarBotoes(){
                return (
                  this.gruposSelecionados.length > 0 ||
                  this.itensIndividuaisSelecionados.length > 0 ||
                  this.possuiItensParaRemover
                ) && this.licitacao.publicado
            },
            itensCredenciamento(){
                return this.lotesLicitacao.map(lote => {
                    return {
                        licitacaoLoteItemId: lote.id,
                        itemCompraId: lote.itemCompra.id,
                        sequencia: lote.numSequencia,
                        descricaoSequencia: lote.licitacaoLote.lote.resumoDescricao,
                        descricao: lote.itemCompra.codigo + ' - ' + lote.itemCompra.descricaoCompleta,
                        quantidade: lote.quantidade,
                        unidade: lote.itemCompra.unidade.descricao,
                        valorUnitario: lote.valorUnitario,
                        valorTotal: lote.valorTotal,
                        ehItemSolicitacaoCredenciamento: lote.ehItemSolicitacaoCredenciamento,
                        tipo: lote.itemCompra.tipo
                    }
                })
            },
            grupos() {
                const gruposMap = new Map()
                
                this.itensCredenciamento.forEach(item => {
                    const resumoDescricao = item.descricaoSequencia
                    
                    if (resumoDescricao && (resumoDescricao.toLowerCase().includes('lote') || resumoDescricao.toLowerCase().includes('grupo'))) {
                        const loteId = resumoDescricao
                        
                        if (!gruposMap.has(loteId)) {
                            gruposMap.set(loteId, {
                                loteId: loteId,
                                resumoDescricao: resumoDescricao,
                                itens: []
                            })
                        }
                        
                        const grupo = gruposMap.get(loteId)
                        grupo.itens.push(item)
                    }
                })
                
                return Array.from(gruposMap.values())
            },
            itensIndividuais() {
                return this.itensCredenciamento.filter(item => {
                    const resumoDescricao = item.descricaoSequencia
                    return !resumoDescricao || (!resumoDescricao.toLowerCase().includes('lote') && !resumoDescricao.toLowerCase().includes('grupo'))
                })
            },
            possuiGrupos() {
                return this.grupos.length > 0
            },
            possuiItensIndividuais() {
                return this.itensIndividuais.length > 0
            },
            possuiItensParaRemover() {
                try {
                    const atuais = new Set([
                        ...(this.itensIndividuaisSelecionados || []).map(i => i.licitacaoLoteItemId),
                        ...((this.gruposSelecionados || []).flatMap(grupoId => {
                            const grupo = (this.grupos || []).find(g => g.loteId === grupoId)
                            return (grupo && grupo.itens) ? grupo.itens.map(item => item.licitacaoLoteItemId) : []
                        }))
                    ])

                    const anteriores = new Set((this.itensCredenciamento || [])
                        .filter(item => item.ehItemSolicitacaoCredenciamento)
                        .map(item => item.licitacaoLoteItemId))

                    for (const id of anteriores) {
                        if (!atuais.has(id)) {
                            return true
                        }
                    }
                    return false
                } catch (e) {
                    return false
                }
            },
            ...mapState(['loki', 'licitacao', 'fornecedorAceite', 'lotesLicitacao', 'credenciamento', 'propostaResumo']),
            headersValidos(){
                return this.headers
            },
            deveBloqueiarAcoesDaTabela(){
                return this.propostaResumo && this.propostaResumo.enviada
            },
            ehCredenciamentoAguardandoAbertura() {
              if (this.licitacao.publicado) {
                const dataAbertura = moment(this.licitacao.dataAbertura)
                const dataAtual = moment(new Date())

                return dataAtual.isBefore(dataAbertura)
              }
              return false;
            },
            ...mapState(['licitacao'])
        },
        async mounted() {
            this.credenciamentoId = this.$route.params.id
            this.buscarLicitacao(this.$route.params.id)
            await this.buscarLotesCredenciamento()
            await this.buscarSolicitacaoCredenciamentoDoFornecedor()
            if (this.ehCredenciamentoAguardandoAbertura) {
              this.pollingTimer = setInterval(() => {
                if (!this.ehCredenciamentoAguardandoAbertura) {
                  this.buscarLicitacao(this.$route.params.id)
                  clearInterval(this.pollingTimer)
                  this.pollingTimer = null
                }
              }, 5000)
            }
        },
        methods: {
            getTipoMaterialServico(sigla, chave) {
              const mod = require('@/commons/constants/tipo-item-material-servico').default || {};
              const lista = Object.values(mod);
              const norm = v => (v || '').toString().trim().toUpperCase();
              const t = norm(sigla);
              let item = lista.find(el => norm(el.sigla) === t || norm(el.value) === t || norm(el.text) === t);
              if (!item) {
                if (t.startsWith('M')) item = lista.find(el => norm(el.value) === 'MATERIAL');
                if (!item && (t.startsWith('S') || t.startsWith('SERV'))) item = lista.find(el => norm(el.value) === 'SERVICO');
              }
              return item ? item[chave] : null;
            },
            // ===== Helpers para Tipo/Sequência
            containsIgnoreCase(src, needle) {
              if (!src || !needle) return false;
              try { return new RegExp(needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i').test(src); } catch (e) { return false; }
            },
            isGrupoDesc(desc) { return this.containsIgnoreCase(desc, 'grupo') || this.containsIgnoreCase(desc, 'lote'); },
            isItemDesc(desc) { return this.containsIgnoreCase(desc, 'item'); },
            extractNumberFromDesc(desc, keyword) {
              if (!desc) return null;
              const cleaned = desc.replace(new RegExp(keyword, 'ig'), '').trim()
                                  .replace(/[^0-9.]+/g, '')
                                  .replace(/^[.]+|[.]+$/g, '');
              return cleaned && cleaned.length ? cleaned : null;
            },
            getTipoItemFromDescricao(descricaoSequencia) {
              if (this.isGrupoDesc(descricaoSequencia)) return descricaoSequencia;
              if (this.isItemDesc(descricaoSequencia)) return 'Item';
              return 'Item';
            },
            getSequenciaFromItemRow(row) {
              const desc = row && row.descricaoSequencia;
              if (this.isGrupoDesc(desc)) {
                return row && row.sequencia != null ? row.sequencia : null;
              }
              if (this.isItemDesc(desc)) {
                return this.extractNumberFromDesc(desc, 'item');
              }
              return row && row.sequencia != null ? row.sequencia : null;
            },
            async processarSavlarItensEAvancar() {
                const totalSelecionados = this.itensIndividuaisSelecionados.length + this.getTotalItensGruposSelecionados()
                if (totalSelecionados <= 0 && !this.possuiItensParaRemover)
                    throw new Error('É necessário selecionar ao menos um item ou grupo ou possuir itens para remover.')

                let itensSelecionadosAgora = []

                itensSelecionadosAgora = itensSelecionadosAgora.concat(this.itensIndividuaisSelecionados.map(item => ({
                    licitacaoLoteItemId: item.licitacaoLoteItemId,
                    itemCompraId: item.itemCompraId,
                })))

                this.gruposSelecionados.forEach(grupoId => {
                    const grupo = this.grupos.find(g => g.loteId === grupoId)
                    if (grupo) {
                        grupo.itens.forEach(item => {
                            itensSelecionadosAgora.push({
                                licitacaoLoteItemId: item.licitacaoLoteItemId,
                                itemCompraId: item.itemCompraId,
                            })
                        })
                    }
                })

                const mapaAtual = new Map()
                itensSelecionadosAgora.forEach(i => {
                    if (!mapaAtual.has(i.licitacaoLoteItemId)) {
                        mapaAtual.set(i.licitacaoLoteItemId, i)
                    }
                })
                itensSelecionadosAgora = Array.from(mapaAtual.values())

                const itensAnteriormenteSelecionados = []
                ;(this.itensIndividuais || []).forEach(item => {
                    if (item.ehItemSolicitacaoCredenciamento) {
                        itensAnteriormenteSelecionados.push({
                            licitacaoLoteItemId: item.licitacaoLoteItemId,
                            itemCompraId: item.itemCompraId,
                        })
                    }
                })
                ;(this.grupos || []).forEach(grupo => {
                    (grupo.itens || []).forEach(item => {
                        if (item.ehItemSolicitacaoCredenciamento) {
                            itensAnteriormenteSelecionados.push({
                                licitacaoLoteItemId: item.licitacaoLoteItemId,
                                itemCompraId: item.itemCompraId,
                            })
                        }
                    })
                })
                const mapaAnterior = new Map()
                itensAnteriormenteSelecionados.forEach(i => {
                    if (!mapaAnterior.has(i.licitacaoLoteItemId)) {
                        mapaAnterior.set(i.licitacaoLoteItemId, i)
                    }
                })
                const anterioresUnicos = Array.from(mapaAnterior.values())

                const setAtuais = new Set(itensSelecionadosAgora.map(i => i.licitacaoLoteItemId))
                const setAnteriores = new Set(anterioresUnicos.map(i => i.licitacaoLoteItemId))

                const itensInserir = itensSelecionadosAgora.filter(i => !setAnteriores.has(i.licitacaoLoteItemId))
                const itensRemover = anterioresUnicos.filter(i => !setAtuais.has(i.licitacaoLoteItemId))

                const intersecao = itensInserir.some(i => setAnteriores.has(i.licitacaoLoteItemId)) || itensRemover.some(i => setAtuais.has(i.licitacaoLoteItemId))
                if (intersecao) {
                    throw new Error('Conflito de seleção detectado. Por favor, tente novamente.')
                }

                const { itens } = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.SOLICITACAO.SALVAR_ITENS, {
                    credenciamentoId: this.credenciamentoId,
                    itensInserir,
                    itensRemover
                })

                this.$store.commit(mutationTypes.CREDENCIAMENTO.SET_SOLICITACAO_CONTEM_ITENS, itens.length > 0)

                await this.buscarLotesCredenciamento()
                this.itensIndividuaisSelecionados = []
                this.gruposSelecionados = []

                await this.$router.push({
                    name: 'credenciamentoFornecedorDocumentos',
                    params: {id: this.credenciamentoId}
                })
            },
            getTotalItensGruposSelecionados() {
                let total = 0
                this.gruposSelecionados.forEach(grupoId => {
                    const grupo = this.grupos.find(g => g.loteId === grupoId)
                    if (grupo) {
                        total += grupo.itens.length
                    }
                })
                return total
            },
            isGrupoSelecionado(grupoId) {
                return this.gruposSelecionados.includes(grupoId)
            },
            toggleGrupoSelection(grupoId, selecionado) {
                if (selecionado) {
                    if (!this.gruposSelecionados.includes(grupoId)) {
                        this.gruposSelecionados.push(grupoId)
                    }
                } else {
                    const index = this.gruposSelecionados.indexOf(grupoId)
                    if (index > -1) {
                        this.gruposSelecionados.splice(index, 1)
                    }
                }
            },
            marcarDesmarcarTodosItensIndividuais() {
                if (this.itensIndividuaisSelecionados.length) {
                    this.itensIndividuaisSelecionados = []
                } else {
                    this.itensIndividuaisSelecionados = this.itensIndividuais.slice()
                }
                this.itensSelecionados = this.itensIndividuaisSelecionados
            },
            changeSort (column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column
                    this.pagination.descending = false
                }
            },
            async buscarLotesCredenciamento(){
                this.setMensagemLoading('Atualizando listagem de lotes...')
                await this.$store.dispatch(actionTypes.CREDENCIAMENTO.BUSCAR_LOTES_CRDENCIAMENTO, this.credenciamentoId)
                this.setSolicitacaoContemItens()
            },
            setSolicitacaoContemItens(){
                    const solicitacaoPossuiItens = this.itensCredenciamento.some(lote => lote.ehItemSolicitacaoCredenciamento)
                    this.$store.commit(mutationTypes.CREDENCIAMENTO.SET_SOLICITACAO_CONTEM_ITENS, (solicitacaoPossuiItens))
            },
            async processarEventoCancelarParticipacao(item) {
                const data = {
                    credenciamentoId: this.credenciamentoId,
                    licitacaoLoteItemId: item.licitacaoLoteItemId
                }
                await this.$store.dispatch(actionTypes.CREDENCIAMENTO.CANCELAR_PARTICIPACAO_LOTES_CRDENCIAMENTO, data)
                await this.buscarLotesCredenciamento()
            },
            async buscarSolicitacaoCredenciamentoDoFornecedor(){
                await this.$store.dispatch(actionTypes.BUSCAR_PROPOSTA_RESUMO, this.credenciamentoId)
            },
            ...mapActions({
              buscarLicitacao: actionTypes.BUSCAR_LICITACAO
            }),
        },
        watch: {
            itensSelecionados(){
                this.setSolicitacaoContemItens()
            },
            itensIndividuaisSelecionados() {
                this.setSolicitacaoContemItens()
            },
            gruposSelecionados() {
                this.setSolicitacaoContemItens()
            },
            grupos: {
                handler(novosGrupos) {
                    this.paineisGrupos = this.grupos.map(() => true)
                    if (!this.selecaoGruposInicializada && Array.isArray(novosGrupos) && novosGrupos.length > 0) {
                        const selecionadosIds = (novosGrupos || [])
                            .filter(grupo => (grupo.itens || []).some(item => item.ehItemSolicitacaoCredenciamento))
                            .map(grupo => grupo.loteId)
                        if (selecionadosIds.length) {
                            this.gruposSelecionados = Array.from(new Set([...(this.gruposSelecionados || []), ...selecionadosIds]))
                        }
                        this.selecaoGruposInicializada = true
                    }
                },
                immediate: true
            },
            itensIndividuais: {
                handler(novosItens) {
                    if (!this.selecaoInicializada && Array.isArray(novosItens) && novosItens.length > 0) {
                        const selecionadosPorFlag = (novosItens || []).filter(item => item.ehItemSolicitacaoCredenciamento)
                        if (selecionadosPorFlag.length) {
                            this.itensIndividuaisSelecionados = selecionadosPorFlag.slice()
                            this.itensSelecionados = this.itensIndividuaisSelecionados
                        }
                        this.selecaoInicializada = true
                    }
                },
                immediate: true
            }
        }
    }
</script>

<style scoped>
.az-credenciamento-fornecedor-itens .titulo-secao {
    font-size: 18px;
    font-weight: bold;
    color: #3a6861;
    margin-bottom: 15px;
}

.az-credenciamento-fornecedor-itens .container-grupos, 
.az-credenciamento-fornecedor-itens .container-itens-individuais {
    margin-bottom: 20px;
}

.az-credenciamento-fornecedor-itens .painel-grupos .painel-grupos__linha {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    margin-bottom: 10px;
}

.az-credenciamento-fornecedor-itens .painel-grupos .cabecalho-grupo {
    display: flex;
    align-items: center;
    gap: 10px;
}

.az-credenciamento-fornecedor-itens .painel-grupos .info-grupo {
    color: #666;
    font-size: 12px;
    font-weight: normal;
    margin-left: 5px;
}

.az-credenciamento-fornecedor-itens ::v-deep .painel-grupos .cabecalho-grupo .v-input--selection-controls .v-label {
    color: #104D75 !important;
    font-weight: 500;
}

.az-credenciamento-fornecedor-itens .painel-grupos .cabecalho-grupo strong {
    color: #104D75;
}

.v-btn--small {
    padding: 0 15px !important;
}

.botao-acao {
    margin: 0 0 20px 0;
    text-transform: none;
}

.botao-acao .icone-botao {
    margin-right: 5px;
}

.az-credenciamento-fornecedor-itens ::v-deep .v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.az-credenciamento-fornecedor-itens ::v-deep .v-input--selection-controls .v-input__slot {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.az-table-list ::v-deep .v-input__slot {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
.tabela-itens-grupo td, 
.tabela-itens-individuais td {
  padding: 12px 16px !important;
  vertical-align: middle;
}

.no-wrap {
  white-space: nowrap;
}
</style>
